//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import countdown from '~/mixins/countdown'
import PromotionTournamentBottomMenu from '~/components/promotion-tournament/bottom-menu.vue'
import PromotionTournamentPodiumRow from '~/components/promotion-tournament/podium-row.vue'
import PromotionTournamentRankingRow from '~/components/promotion-tournament/ranking-row.vue'
import {parseDate} from "../../utils/parseDate";

export default {
  name: 'PromotionTournamentPanel',
  components: { PromotionTournamentBottomMenu, PromotionTournamentPodiumRow, PromotionTournamentRankingRow },
  mixins: [countdown],
  props: {
    tournamentId: { type: [Number, String], required: true },
    mode: {
      type: String,
      default: 'ranking',
      validator: (v) => ['ranking', 'rules', 'prizes', 'markets'].includes(v)
    }
  },
  data() {
    return {
      optInLoading: false
    }
  },
  computed: {
    ...mapGetters('tournaments', ['byId']),
    tournament() {
      return this.byId(this.tournamentId)
    },
    tournamentTitle() {
      return this.tournament ? this.tournament.title : ''
    },
    remainingTime() {
      return this.tournament ? this.formatRemaining(this.tournament.endsAt) : ''
    },
    hasStarted() {
      return !!this.tournament && parseDate(this.tournament.startsAt).getTime() <= this.nowTimestamp
    },
    startDateLabel() {
      if (!this.tournament || !this.tournament.startsAt) return ''
      const d = parseDate(this.tournament.startsAt)
      return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },
    disabledTabs() {
      return this.hasStarted ? [] : ['ranking']
    },
    bannerStyle() {
      return this.tournament && this.tournament.bannerImage
        ? { backgroundImage: `url(${this.tournament.bannerImage})` }
        : {}
    },
    description() {
      return this.tournament ? this.tournament.description : ''
    },
    prizesDescription() {
      return this.tournament ? this.tournament.prizesDescription : ''
    },
    // NOTE: not in the current API contract sample — needs a `rulesParagraphs` field
    // added to the tournament detail response, or point this at wherever rules text lives.
    rulesParagraphs() {
      return (this.tournament && this.tournament.rulesParagraphs) || []
    },
    prizesTable() {
      return (this.tournament && this.tournament.prizesTable) || []
    },
    currentUser() {
      return this.tournament ? this.tournament.currentUser : null
    },
    // Always shows ranks 1-3 and the last rank of the top N (leaderboardSize); if the current
    // user falls in between, their row is "un-collapsed" into the gap, merging with an adjacent
    // boundary (3 or N) with no gap marker when they're directly adjacent to it, or with a gap
    // on both sides otherwise.
    rankingRows() {
      if (!this.tournament) return []
      const n = this.tournament.leaderboardSize || this.tournament.leaderboard.length
      const topN = this.tournament.leaderboard.slice(0, n)
      const currentPos = this.currentUser ? this.currentUser.position : null
      const withFlag = (r) => ({ ...r, isCurrentUser: currentPos != null && r.position === currentPos })

      // Fewer players than the leaderboard size — nothing to collapse, just show them all in order.
      if (topN.length < n) {
        return topN.map((r) => ({ row: withFlag(r), gapBefore: false }))
      }

      const rows = []
      topN
        .filter((r) => r.position <= 3)
        .forEach((r) => rows.push({ row: withFlag(r), gapBefore: false }))

      const last = topN.find((r) => r.position === n)
      // Skip re-adding `last` if it's already part of the first-3 block (n <= 3), and only show
      // a gap before it when there's actually at least one hidden rank between 3 and n (n > 4).
      const lastNeedsOwnRow = !!last && last.position > 3

      if (currentPos >= 4 && currentPos <= n - 1) {
        const middleRow = topN.find((r) => r.position === currentPos)
        if (middleRow) rows.push({ row: withFlag(middleRow), gapBefore: currentPos !== 4 })
        if (lastNeedsOwnRow) rows.push({ row: withFlag(last), gapBefore: currentPos !== n - 1 })
      } else if (lastNeedsOwnRow) {
        rows.push({ row: withFlag(last), gapBefore: last.position !== 4 })
      }

      return rows
    },
    // Only needed below the top-N block when the user's rank isn't already shown in it
    showPinnedUser() {
      const n = this.tournament ? this.tournament.leaderboardSize || this.tournament.leaderboard.length : 0
      return !!(this.currentUser && this.currentUser.position > n)
    },
    // NOTE: guessed mapping — the API contract only has eligibleSports/Leagues/BetTypes (structured
    // tags used by EligibilityList on the promo page), not a markets blurb. Using bet types as a
    // stand-in until it's confirmed what "markets" tab content should actually be.
    marketsText() {
      return this.tournament && this.tournament.eligibleBetTypes
        ? this.tournament.eligibleBetTypes.join(', ')
        : ''
    }
  },
  created() {
    if (!this.tournament) {
      this.$store.dispatch('tournaments/fetchDetail', this.tournamentId)
    }
  },
  methods: {
    async optIn() {
  if (!this.tournament || this.tournament.optedIn) return
  this.optInLoading = true
  try {
    const promotionId = this.tournament.pageId;
    let response = await this.$new_cms().post('/api/cms/content/opt-in', {page_id: promotionId})
    if (_.get(response, 'data.additional.result')) {
      this.$modal.show('modal-generic', {
        title: this.$t('Success!'),
        content: this.$t(_.get(response, 'data.message')),
      })
      const currentList = (this.user && Array.isArray(this.user.opted_in_promotions))
          ? [...this.user.opted_in_promotions]
          : [];

      const alreadyOptedIn = currentList.some(p => p && p.page_id === promotionId);

      if (!alreadyOptedIn) {
        currentList.push({ page_id: promotionId });
        this.$store.commit('auth/storeUser', { opted_in_promotions: currentList });
      }

      // NEW: flip the tournaments module's cached optedIn flag too, so the FAB (fabState)
      // and this panel (ranking view / bottom menu) update immediately, without waiting
      // for a future refetch to re-derive it from the refreshed auth.user.
      this.$store.dispatch('tournaments/markOptedIn', this.tournamentId)
    } else {
      this.$modal.show('modal-generic', {
        title: this.$t('Sorry!'),
        content: this.$t(_.get(response, 'data.message')),
      })
    }
  } catch (error) {
    console.error(error)
  } finally {
    this.optInLoading = false
  }
}
  }
}
